<template>
  <div></div>
</template>

<script>
export default {
  async created() {
    await this.createEasemob();
    this.init();
  },
  methods: {
    init() {
      var data = this.$route.query;
      window.easemobim = window.easemobim || {};
      window.easemobim.config = {
        configId: "58683963-1d43-40ea-8401-270e6c5937f6",
        visitor: {
          trueName:data.userName?data.userName:"",
          qq:"",
          phone:data.userName?data.userName:"",
          companyName: "",
          userNickname:data.nickName?data.nickName:"",
          description:data.remark?data.remark:"",
          email: data.email?data.email:"",
        },
      };
      window.easemobim.bind();
    },
    createEasemob() {
      return new Promise((resolve) => {
        const mapScript = document.createElement("script");
        mapScript.type = "text/javascript";
        mapScript.src =
          "//101973.kefu.easemob.com/webim/easemob.js?configId=58683963-1d43-40ea-8401-270e6c5937f6";
        document.body.appendChild(mapScript);
        mapScript.onload = () => {
          resolve();
        };
      });
    },
  },
};
</script>

<style></style>
